<template>
  <div class="exception">
    <div class="img">
      <img src="https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg" />
    </div>
    <div class="content">
      <h1>404</h1>
      <div class="desc">对不起，你访问的页面走丢了！</div>
      <div class="action">
        <span style="color:red;font-size: 28px">
         {{time}}s
        </span>后自动跳转至首页
        <br/>
        <a-button type="primary" @click="goBack">返回首页</a-button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      time: ''
    }
  },
  created () {
    this.timer()
  },
  methods: {
    timer () {
      let t = 11
      let timeCount = setInterval(() => {
        t--
        this.time = t
        if (t < 1) {
          this.goBack()
          clearInterval(timeCount)
        }
      }, 10)
    },
    goBack () {
      this.$router.push('/dashboard/workplace')
    }
  }
}
</script>

<style lang="less" scoped>
  .exception{
    min-height: 500px;
    height: 80%;
    align-items: center;
    text-align: center;
    margin-top: 150px;
    .img{
      display: inline-block;
      padding-right: 52px;
      zoom: 1;
      img{
        height: 360px;
        max-width: 430px;
      }
    }
    .content{
      display: inline-block;
      flex: auto;
      h1{
        color: #434e59;
        font-size: 72px;
        font-weight: 600;
        line-height: 72px;
        margin-bottom: 24px;
      }
      .desc{
        color: rgba(0,0,0,.45);
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 16px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/exception/404.vue